import React from 'react';
import {Button} from 'react-bootstrap';
import {PermissionRequired, Action, ListActions, Icon} from '../../components';
import {ModalsAction, PriceAlertsAction} from '../../actions';
import {Activities} from '../../constants';
import {PriceAlertsStore} from '../../stores';

export default React.createClass({
  render() {
    const alert = this.props.rowData;
    const isNew = alert.status === 'new';

    return (
      <ListActions>
        <PermissionRequired requiredRoles={Activities.WRITE_PRICES} user={this.props.metadata.user}>
          {isNew && (
            <span>
              <Button
                bsSize="xs"
                bsStyle="primary"
                onClick={this.handleResolveClick}
                title="Resolve Alert">
                <Icon fa="check" /> Resolve
              </Button>
              {' '}
              <Button
                bsSize="xs"
                bsStyle="default"
                onClick={this.handleSkipClick}
                title="Skip Alert">
                <Icon fa="forward" /> Skip
              </Button>
              {' '}
            </span>
          )}
          <Button
            bsSize="xs"
            bsStyle="info"
            onClick={this.handleHistoryClick}
            title="View History">
            <Icon fa="history" />
          </Button>
        </PermissionRequired>
      </ListActions>
    );
  },

  handleResolveClick() {
    ModalsAction.show(100, this.props.rowData); // 100 = Resolve Alert Modal ID
  },

  handleSkipClick() {
    ModalsAction.show(101, this.props.rowData); // 101 = Skip Alert Dialog ID
  },

  handleHistoryClick() {
    const alertId = this.props.rowData.id;
    
    // Check if alert data with history already exists in store
    const alerts = PriceAlertsStore.get('priceAlerts');
    const entities = PriceAlertsStore.get('entities');
    
    let hasHistoryInStore = false;
    if (alerts && alerts.has(String(alertId))) {
      const alert = alerts.get(String(alertId));
      const alertData = alert.toJS();
      
      // Check if history exists and is populated
      if (alertData.history && alertData.history.length > 0 && entities) {
        const entitiesJS = entities.toJS();
        // Verify that ALL history entities are actually in the store
        if (entitiesJS.priceAlertHistory && alertData.history.every(historyId => entitiesJS.priceAlertHistory[historyId])) {
          hasHistoryInStore = true;
        }
      }
    }
    
    // Only fetch if data is not already in store
    if (!hasHistoryInStore) {
      PriceAlertsAction.getById(alertId);
    }
    
    // Show modal immediately
    ModalsAction.show(102, this.props.rowData); // 102 = History Modal ID
  }
});
